import { render } from "./ReportUserByFlowCount.vue?vue&type=template&id=c1c28d1a&ts=true"
import script from "./ReportUserByFlowCount.vue?vue&type=script&lang=ts"
export * from "./ReportUserByFlowCount.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ulucefe\\source\\repos\\birimza.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__